import { NumericAggregation } from "@/shared/domain/metrics";

/**
 * Title for a dashboard card showing an aggregated metric, e.g.
 * "mean of battery_voltage". Shared by the chart card and the trend tile so
 * both render the same schema. The aggregation token is rendered verbatim
 * (lowercase, as stored).
 */
export function getCardTitle(
  metricName: string,
  aggregation: NumericAggregation,
): string {
  return `${aggregation} of ${metricName}`;
}
